import clsx from 'clsx'
import { useCallback } from 'react'
import { DoubleArrow } from '../../primitives/index.ts'
import type { UpdateFunction } from '../hooks/useQueryState/useQueryState.ts'
import classes from './navigation-collapsed.module.css'

export type Props = {
  sidebarPosition: 'row' | 'row-reverse'
  setCollapsed: UpdateFunction<boolean>
}

export function NavigationCollapsed(props: Props) {
  const { sidebarPosition, setCollapsed } = props

  // --------------------------------------------
  // Sidebar state

  const handleExpandSidebar = useCallback(() => {
    setCollapsed(false)
  }, [setCollapsed])

  const iconCls = clsx(classes.icon, sidebarPosition === 'row' ? classes.iconRow : classes.iconRowReverse)
  return (
    <div className={classes.root}>
      <span data-tooltip="Show the sidebar" data-tooltip-position={sidebarPosition === 'row' ? 'right' : 'left'}>
        <button className={classes.btn} onClick={handleExpandSidebar} type="button">
          <DoubleArrow className={iconCls} />
        </button>
      </span>
    </div>
  )
}
